import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { Help } from '../help/help';
import { Back, Content, Wrapper, Title, WithHelp } from './popup2.styled';

/**
 * Is there a scrollable (overflowing) element between target and body that can scroll in the wheel direction
 */
function canScrollInside(target, deltaY) {
  let el = target instanceof Element ? target : null;
  while (el && el !== document.body && el !== document.documentElement) {
    const { overflowY } = window.getComputedStyle(el);
    if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
      if (deltaY < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight) {
        return true;
      }
    }
    el = el.parentElement;
  }
  return false;
}

function lockScroll(e) {
  // allow scrolling inside dropdowns/lists (e.g. custom select menus)
  if (canScrollInside(e.target, e.deltaY ?? -e.wheelDelta)) {
    return;
  }
  e.preventDefault();
}

export const Popup2 = (props) => {
  const { close, children, theme, w, top, title, help = '', ...rest } = props;

  useEffect(() => {
    document.body.addEventListener('mousewheel', lockScroll, { passive: false });
    // mousewheel touchmove

    return () => {
      document.body.removeEventListener('mousewheel', lockScroll, { passive: false });
    };
  }, []);

  /**
   * close popup
   */
  const closePopup = () => {
    if (close) {
      close();
    }
  };

  /**
   * cancel click event propogation
   * @param {*} event
   */
  const cancelClick = (event) => {
    event.stopPropagation();
  };

  return (
    <Back onClick={closePopup}>
      <Wrapper theme={theme} w={w} top={top} onClick={cancelClick}>
        <Content {...rest}>
          {help && title && (
            <WithHelp>
              <Title>{title}</Title>
              <Help info={help} className="white" w={420} />
            </WithHelp>
          )}
          {!help && title && <Title>{title}</Title>}
          {children}
        </Content>
      </Wrapper>
    </Back>
  );
};

Popup2.propTypes = {
  w: PropTypes.number,
  top: PropTypes.number,
  close: PropTypes.func,
  children: PropTypes.any,
  theme: PropTypes.string,
  title: PropTypes.string,
};

Popup2.defaultProps = {
  w: 600,
};
